import systemManage from './company/systemManage'
import newsManage from './company/newsManage'
import honorManage from './company/honorManage'

export default {
  systemManage, newsManage, honorManage
}



// WEBPACK FOOTER //
// ./src/api/index.js